import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'sm-alert-for-email',
  templateUrl: './alert-for-email.component.html',
  styleUrls: ['./alert-for-email.component.scss']
})
export class AlertForEmailComponent implements OnInit {

  constructor(public activeModal :  MatDialogRef<AlertForEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }
  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.activeModal.close(true);
  }

  public dismiss() {
    this.activeModal.close();
  }

}